import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { memo, useCallback } from "react";
import { useFormStepperContext } from "../../../../store/contexts/FormStepperContext";
import { FormStepContainer } from "./FormStepContainer/FormStepContainer";
import { AllStepsForm } from "./AllStepsForm/AllStepsForm";
import { IFormSteps } from "./models";

export const FormSteps = memo(
  ({
    endComponent,
    steps,
    layoutForm,
    questions,
    hasAnswerDate,
  }: IFormSteps) => {
    const { activeStep } = useFormStepperContext();

    const handleFinish = useCallback(() => {}, []);

    if (activeStep >= steps.length && endComponent) {
      return <FormStepContainer>{endComponent}</FormStepContainer>;
    }

    if (layoutForm?.code === "1" && questions) {
      return (
        <Box sx={{ margin: "0 auto", mt: 5, width: "80%", pb: 4 }}>
          <AllStepsForm
            questions={questions}
            hasAnswerDate={hasAnswerDate ?? false}
            onFinish={handleFinish}
            stepsLength={steps.length}
          />
        </Box>
      );
    }

    return (
      <Box sx={{ margin: "0 auto", mt: 5, width: "80%" }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((step) => (
            <Step key={step.step}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {steps.map((step) => {
          if (step.step === activeStep) {
            return (
              <FormStepContainer key={step.step}>
                <>{step.component}</>
              </FormStepContainer>
            );
          }
          return null;
        })}
      </Box>
    );
  },
);
